import { INFO_ROBCO_BASE_URL } from '@/Constants';

export enum ResourceTab {
  WHITE_PAPERS = 'whitePapers',
  SUCCESS_STORIES = 'successStories',
  CATALOGUE = 'catalogue',
  TECHNICAL_DATA = 'technicalData',
  VIDEOS = 'videos',
  OTHER = 'other',
}

export interface Resource {
  title: string;
  description: string;
  href: string;
  type: string;
}
export interface IResources {
  en: Resource[];
  de: Resource[];
}

export const resources = {
  [ResourceTab.CATALOGUE]: {
    en: [
      {
        title: 'Product Catalogue',
        description:
          'Our product catalog lists all essential details that help buyers to make a purchase decision. These includes product features, technical descriptions, configurations, use cases, and more.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Product%20Catalog/PC_Robco_EN.pdf`,
      },
      {
        title: 'RobCase',
        description:
          'Introducing RobCase, our innovative sales tool for showcasing robotic solutions at customer locations. Designed to demonstrate the remarkable modularity, flexibility, and ease of use of our products.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Product%20Catalog/RobCase%20Catalogue.pdf`,
      },
      {
        title: 'The greatest of all times: RobCo’s XL module',
        description:
          'Welcome to the future of automation! With the XL module from RobCo, we offer you a groundbreaking innovation in lightweight robotics - the ideal solution for companies that want maximum efficiency and flexibility without compromising on costs. The XL module impresses with a payload of up to 40kg or a reach of 2100mm and adapts flexibly to your production needs.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/XL%20Module/RobCo_XL_Module_EN.pdf`,
      },
      {
        title:
          "RobVision - Revolutionize your production with RobCo's AI vision system.",
        description:
          'Automation has never been so precise, flexible and cost-efficient. With RobVision, you can take your processes to the next level by integrating the latest AI-based image processing into your production chain. Our innovative vision system offers significant benefits for industrial companies that work in dynamic environments and want to make their automation more flexible, intelligent and adaptable.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/RobVision%202-Pager/RobVision_Doc_EN.pdf`,
      },
    ],
    de: [
      {
        title: 'Produktkatalog',
        description:
          'Unser Produktkatalog listet alle wesentlichen Details auf, die Käufern bei der Kaufentscheidung helfen. Dazu gehören Produktfunktionen, technische Beschreibungen, Konfigurationen, Anwendungsfälle und mehr.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Product%20Catalog/PC_Robco_DE.pdf`,
      },
      {
        title: 'RobKoffer',
        description:
          'Wir stellen Ihnen RobKoffer vor, unser innovatives Verkaufstool zur Präsentation von Roboterlösungen an Kundenstandorten. Entwickelt, um die bemerkenswerte Modularität, Flexibilität und Benutzerfreundlichkeit unserer Produkte zu demonstrieren.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Product%20Catalog/RobKoffer%20Catalogue.pdf`,
      },
      {
        title: 'The greatest of all times: RobCo’s XL-Modul',
        description:
          'Willkommen in der Zukunft der Automatisierung. Mit dem XL-Modul von RobCo bieten wir Ihnen eine bahnbrechende Innovation in der Leichtbaurobotik – die ideale Lösung für Unternehmen, die auf maximale Effizienz und Flexibilität setzen, ohne Kompromisse bei den Kosten einzugehen. Das XL-Modul überzeugt mit einer Traglast von bis zu 40kg oder einer Reichweite von 2100mm und passt sich flexibel an Ihre Produktionsbedürfnisse an.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/XL%20Module/RobCo_XL_Modul_DE.pdf`,
      },
      {
        title:
          "RobVision - Revolutionieren Sie Ihre Produktion mit RobCo's KI-Vision-System",
        description:
          'Automatisierung war noch nie so präzise, flexibel und kosteneffizient. Mit RobVision bringen Sie Ihre Prozesse auf ein neues Level, indem Sie die neueste KI-basierte Bildverarbeitung in Ihre Produktionskette integrieren. Unser innovatives Vision-System bietet erhebliche Vorteile für industrielle Unternehmen, die in dynamischen Umgebungen arbeiten und ihre Automatisierung flexibler, intelligenter und anpassungsfähiger gestalten wollen.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/RobVision%202-Pager/RobVision_Doc_DE.pdf`,
      },
    ],
  },
  [ResourceTab.WHITE_PAPERS]: {
    en: [
      {
        title: 'Automation for Beginners',
        description:
          'How modular robotics can give your company a decisive advantage',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Whitepapers/Whitepaper%20Automation%20for%20beginners.pdf`,
      },
      {
        title: 'Industry-X: New Concepts for The Use of Robots',
        description:
          'Manufacturing with smart manufacturing, AI and modular robots.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Two-Pager/Modular%20Industrial%20Robots%20Robco%20%5BEN%5D.pdf`,
      },
    ],
    de: [
      {
        title: 'Automatisierung für Einsteiger',
        description:
          'Wie die modulare Robotik Ihrem Unternehmen einen entscheidenden Vorteil verschaffen kann',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Whitepapers/RobCo_WP_Automatisierung_f%C3%BCr_Einsteiger.pdf`,
      },
      {
        title: 'Industrie-X: Neue Konzepte für den Robotereinsatz ',
        description:
          'Wie Sie Ihre Produktivität und Flexibilität in der Fertigung mit intelligenter Fertigung, KI und modularen Robotern steigern können',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Whitepapers/Neue-Konzepte-fuer-den-Robotereinsatz-RobCo-T-Systems.pdf`,
      },
    ],
  },
  [ResourceTab.SUCCESS_STORIES]: {
    en: [
      {
        title: 'Palletizing with DE-VAU-GE',
        description: 'DE-VAU-GE: Cost Savings and Increased Efficiency.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Robco%20Case%20Studies/Success%20Story%20Palletizing%20DE-VAU-GE%20%5BEN%5D.pdf`,
      },
      {
        title: 'Machine Tending with Brecht',
        description: 'Brecht: Reduce Costs and Reduce Idle Time.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Robco%20Case%20Studies/Success%20Story%20Machine%20Tending%20Brecht%20%5BEN%5D.pdf`,
      },
      {
        title: 'Machine Loading with Frank Präzisionsstelle GmbH',
        description:
          'Increase in the machine capacity of Frank Präzisionsteile GmbH',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Robco%20Case%20Studies/Success%20Story%20Machine%20Loading%20Frank%20Pr%C3%A4zisionsstelle%20GmbH%20%5BEN%5D.pdf`,
      },
    ],
    de: [
      {
        title: 'Palettieren mit DE-VAU-GE',
        description: 'DE-VAU-GE: Kostenersparnis und Effizienzsteigerung.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Robco%20Case%20Studies/Success%20Story%20RobCo%20x%20DE-VAU-GE.pdf`,
      },
      {
        title: 'Maschinenbeschickung',
        description: 'Be- und Entladen einer CNC Maschine mit Brecht.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Robco%20Case%20Studies/CASE%20STUDY%20BRECHT%20FINAL.pdf`,
      },
      {
        title: 'Maschinenbeschickung',
        description:
          'Be- und Entladen einer CNC Maschine mit Frank Präzisionsteile.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Robco%20Case%20Studies/Fallstudie%20Maschinenbeladung%20Frank%20Pr%C3%A4zisionsteile%20GmbH%20%5BDE%5D.pdf`,
      },
      {
        title: 'Holzverarbeitung',
        description: 'Pick und Place mit wodewa.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Robco%20Case%20Studies/CASE%20STUDY%20wodewa-1.pdf`,
      },
    ],
  },
  [ResourceTab.TECHNICAL_DATA]: {
    en: [
      {
        title: 'Technical Data',
        description:
          'Our technical data sheet gives you an overview of all technical specifications.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Technical%20Data/Technical%20Specifications%20Robco%20%5BEN%5D.pdf`,
      },
      {
        title: 'Quick Guide',
        description:
          'Get a quick overview over Montage, Installation, Software.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/User%20Manual/Quick%20Guide%20%5BEN%5D.pdf`,
      },
      {
        title: 'RobFlow Documentation',
        description: 'Complete documentation of RobFlow',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/RobFlow%20Documentation.pdf`,
      },
      {
        title: 'User Manual',
        description:
          'Get an introduction to the operation of our modular robot and our no-code software.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/User%20Manual/User%20Manual%20Documentation%20EN.pdf`,
      },
      {
        title: 'Profinet Material',
        description:
          'Required resources to properly configure your SPS to communicate with RobCo via Profinet',
        type: 'zip',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/RobCo%20Profinet%20End-User%20Material%20v1.0.0.zip`,
      },
      {
        title: 'Robot Calibration Documentation',
        description:
          'Required resources to properly calibrate your Robot using RobVision',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/RobCo.Studio/Robot%20Calibration%20Documentation.pdf`,
      },
      {
        title: 'Renderings & CAD-Data',
        description: 'RobCo illustrations and visual assets.',
        type: 'zip',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Robots_Renderings.zip`,
      },
      {
        title: 'Automation Requirements Sheet',
        description:
          'This sheet is designed to capture actionable customer requirements and should be filled by RobCo staff/partner',
        type: 'docx',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Technical%20Data/Automation_requirement_sheet_EN.docx`,
      },
      {
        title: 'Project requirements checklist',
        description:
          'The document to capture project relevant information, for feasibility check and to create specifications.',
        type: 'xlsx',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Draft_Checklist%20for%20customer%20project_ENG.xlsx`,
      },
    ],
    de: [
      {
        title: 'Technische Daten',
        description:
          'Unser technisches Datenblatt gibt Ihnen eine Übersicht über alle technischen Spezifikationen.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Technical%20Data/Technische%20Daten%20Robco%20%5BDE%5D.pdf`,
      },
      {
        title: 'Quick Guide',
        description: 'Kompakte Übersicht über Montage, Installation, Software.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/User%20Manual/Quick%20Guide%20%5BDE%5D.pdf`,
      },
      {
        title: 'RobFlow Dokumentation',
        description: 'Vollständige Dokumentation von RobFlow',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/RobFlow%20Documentation.pdf`,
      },
      {
        title: 'Benutzerhandbuch',
        description:
          'Erhalten Sie eine Einführung in die Bedienung unseres modularen Roboters und unserer No-Code-Software.',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/User%20Manual/Robco%20Benutzerhandbuch.pdf`,
      },
      {
        title: 'Profinet Material',
        description:
          'Erforderliche Ressourcen zur ordnungsgemäßen Konfiguration Ihrer SPS für die Kommunikation mit RobCo über Profinet',
        type: 'zip',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/RobCo%20Profinet%20End-User%20Material%20v1.0.0.zip`,
      },
      {
        title: 'Dokumentation zur Roboterkalibrierung',
        description:
          'Erforderliche Ressourcen zur ordnungsgemäßen Kalibrierung Ihres Roboters mit RobVision',
        type: 'pdf',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/RobCo.Studio/Robot%20Calibration%20Documentation.pdf`,
      },
      {
        title: 'Renderings & CAD-Daten',
        description: 'RobCo Illustrationen und visuelle Daten.',
        type: 'zip',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Robots_Renderings.zip`,
      },
      {
        title: 'Kundenanforderungsdokument',
        description:
          'Dieses Dokument soll umsetzbare Kundenanforderungen erfassen und sollte von RobCo-Mitarbeitern/Partnern ausgefüllt werden.',
        type: 'docx',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Technical%20Data/Automation_requirement_sheet_EN.docx`,
      },
      {
        title: 'Projektanforderungs-Checkliste',
        description:
          'Dokument zur Erfassung projektrelevanter Informationen, zur Machbarkeitsprüfung und zur Erstellung von Spezifikationen.',
        type: 'xlsx',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Draft_Checklist%20for%20customer%20project_ENG.xlsx`,
      },
    ],
  },
  [ResourceTab.VIDEOS]: {
    en: [
      {
        title: 'The greatest of all times: RobCo’s XL module',
        description:
          'More payload, more reach, more possibilities for your production.',
        type: 'mp4',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Videos/RobCo_XL_Module_EN.mp4`,
      },
      {
        title:
          'RobVision: AI-powered vision system for autonomous automation in the industry and logistics',
        description:
          'With RobVision, we present an advanced system that sets new standards in industrial automation. Our AI-based image processing system enables autonomous work even in unstructured and dynamic environments - where traditional robotics reach their limits.',
        type: 'mp4',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Videos/RobVision_EN.mp4`,
      },
    ],
    de: [
      {
        title: 'The greatest of all times: RobCo’s XL-Modul',
        description:
          'Mehr Traglast, mehr Reichweite, mehr Möglichkeiten für Ihre Produktion.',
        type: 'mp4',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Videos/RobCo_XL_Modul_DE.mp4`,
      },
      {
        title:
          'RobVision: Das KI-gestützte Bildverarbeitungssystem für autonome Automatisierung in Industrie und Logistik',
        description:
          'Mit RobVision präsentieren wir Ihnen ein fortschrittliches System, das neue Maßstäbe in der industriellen Automatisierung setzt. Unser KI-gestütztes Bildverarbeitungssystem ermöglicht autonomes Arbeiten selbst in unstrukturierten und dynamischen Umgebungen – dort, wo traditionelle Robotik an ihre Grenzen stößt.',
        type: 'mp4',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Videos/RobVision_DE.mp4`,
      },
    ],
  },
  [ResourceTab.OTHER]: {
    en: [
      {
        title: 'Introducing RobCo',
        description:
          "Get to know the world's first modular and IOT-capable industrial robot.",
        type: 'ppt',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Presentations/Robco_Master_Company_Presentation%20EN.pptx`,
      },
      {
        title: 'Branding Kit',
        description:
          'The RobCo Branding Kit is your all-in-one resource for maintaining a consistent and professional look across all touchpoints. It includes high-quality renderings, a detailed brand guideline, custom fonts, and official logos to help you communicate the RobCo identity effectively.',
        type: 'zip',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Branding%20Kit/07_Branding_Kit.zip`,
      },
      {
        title: 'Press',
        description: 'Read what others say about RobCo.',
        type: 'Web',
        href: 'https://www.robco.de/en/company/press',
      },
      {
        title: 'Videos',
        description: 'Browse videos about our robots.',
        type: 'Web',
        href: 'https://robco.de/en/resources/videos',
      },
    ],
    de: [
      {
        title: 'Vorstellung RobCo',
        description:
          'Lernen Sie den weltweit ersten modularen und IOT-fähigen Industrieroboter kennen.',
        type: 'ppt',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Presentations/Robco_Company_Presentation_DE.pptx`,
      },
      {
        title: 'Branding Kit',
        description:
          'Das RobCo Branding Kit ist Ihre Komplettlösung für einen einheitlichen und professionellen Auftritt über alle Kanäle hinweg. Es enthält hochwertige Renderings, ausführliche Markenrichtlinien, individuelle Schriftarten und offizielle Logos, um die RobCo-Identität wirkungsvoll zu kommunizieren.',
        type: 'zip',
        href: `${INFO_ROBCO_BASE_URL}/hubfs/Branding%20Kit/07_Branding_Kit.zip`,
      },
      {
        title: 'Presse',
        description: 'Lesen Sie, was andere über RobCo sagen.',
        type: 'Web',
        href: 'https://www.robco.de/unternehmen/presse',
      },
      {
        title: 'Videos',
        description: 'Durchsuchen Sie unsere Videos zum RobCo Roboter.',
        type: 'Web',
        href: 'https://www.robco.de/videos',
      },
    ],
  },
};
